export const DELETED_USER_LABEL = "Deleted user";

const DELETED_USERNAME_RE = /^@?(?:deleted_\d+_[0-9a-f]+|deleted_user_[0-9a-f]+)$/i;
const DELETED_USERNAME_TOKEN_RE = /@?(?:deleted_\d+_[0-9a-f]+|deleted_user_[0-9a-f]+)/gi;

export function isDeletedUsername(value) {
  return DELETED_USERNAME_RE.test(String(value || "").trim());
}

export function isDeletedAccountUser(user) {
  if (!user) return false;
  if (
    user.is_deleted_account ||
    user.is_deleted_user ||
    user.author_is_deleted_account ||
    user.sender_is_deleted_account ||
    user.account_deleted ||
    user.deleted_account
  ) {
    return true;
  }

  return [
    user.username,
    user.owner_username,
    user.author_username,
    user.sender_username,
    user.user_username,
    user.handle,
    user.user?.username,
    user.user?.handle,
    user.profile?.username,
    user.author?.username,
    user.sender?.username,
  ].some(isDeletedUsername);
}

export function formatUserHandle(value, { prefixAt = true } = {}) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (isDeletedUsername(raw)) return DELETED_USER_LABEL;

  const clean = raw.replace(/^@/, "");
  return prefixAt ? `@${clean}` : clean;
}

export function formatDeletedAccountText(value) {
  return String(value || "").replace(DELETED_USERNAME_TOKEN_RE, DELETED_USER_LABEL);
}
